<template>
  <div class="title">
    <div :class="[$route.path == '/home' ? 'headernon' : 'header']">
      <div class="headerlogo">
        <router-link to="/home">
          <h1>澄安科技企業社 Cheng An Technology Enterpries</h1>
          <!-- <img class="logo" src="@/assets/logo.png" /> -->
        </router-link>
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="contact" id="content">
      <div class="contacttext">
        <h3 class="contacttitle">聯絡我們</h3>
        <div class="contactcontent">
          <div class="contactcompany">
            <div>
              澄安科技企業社
              <br />
              <span class="contactcompanyen"
                >Cheng An Technology Enterpries</span
              >
            </div>
          </div>
          <div class="contactinfo">
            <span>
              <img class="contacticon" src="@/assets/telphone.svg" />
              <a class="phone_address" href="tel:+886-7-3222669"
                >(07)3747475</a
              >
            </span>
            <span>
              <img class="contacticon" src="@/assets/mail.svg" />
              <a
                class="phone_address"
                href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=chengantech@gmail.com"
                target="_blank"
                >chengantech@gmail.com</a
              >
            </span>
            <span>
              <img class="contacticon" src="@/assets/company.svg" />
              <a
                class="phone_address"
                href="https://maps.app.goo.gl/dWauqUKohu54j1JV8"
                >高雄市仁武區仁雄路510-7號</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.title {
  width: 100%;
}
.headernon {
  display: none;
}
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 5;
  background: url("../assets/title.jpg") center center no-repeat;
  background-size: cover;
}
.headerlogo {
  width: 183px;
  height: 100%;
  position: relative;
  left: 10px;
  background-image: url("../assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position:50%;
  h1 {
    text-indent: 101%;
    overflow: hidden;
    white-space: nowrap;
  }
}
.logo {
  width: 100%;
}
.main {
  width: 100%;
  background: url("../assets/background.jpg") center center no-repeat;
  background-size: cover;
}

a {
  text-decoration: none;
  color: white;
}
.contact {
  width: 100%;
  height: 350px;
  background: #1c1b1a;
}
.contacttext {
  width: 80%;
  margin: auto;
  position: relative;
  top: 70px;
  z-index: 2;
}
.contacttitle {
  z-index: 1;
  font-weight: bold;
  font-size: 1.7em;
  color: rgb(218, 218, 218);
  margin: 0 0 30px 0;
}
.contactcontent {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: space-between;
}
.contactcompany {
  height: 100%;
  color: #f4d271;
  font-size: 1.9em;
  display: flex;
  align-items: center;
}
.contactcompanyen {
  width: 100%;
  display: flex;
  color: #cea945;
  font-size: 0.45em;
}
.contactinfo {
  width: 480px;
  line-height: 40px;
  color: #ffffff;
  display: grid;
  grid-template-columns: 270px 270px;
}
.contactinfo > span {
  width: 100%;
  display: flex;
  align-items: center;
}
.contacticon {
  width: 21px;
  height: 21px;
  margin-right: 10px;
}
@media screen and (max-width: 1000px) {  
  .contactcontent {
    width: 100%;
    height: 150px;
    display: block;
  }
  .contact {
    height: 450px;
  }
}
@media screen and (max-width: 767px) {
  .header {
    height: 60px;
  }
  .headerlogo {
    margin: auto;
    position: static;
  }
  .menudiv {
    width: 100%;
    background-color: rgb(58, 58, 58);
    border-top: 1px solid rgb(114, 114, 114);
    position: fixed;
    bottom: 0;
  }
  .menu {
    width: 100%;
  }
  .elmenuitem {
    width: 25%;
    font-size: 0.7em !important;
  }
  .menuitemspan {
    font-size: 0.8em !important;
    color: rgb(136, 136, 136);
  }  
  .contacttitle {
    font-size: 1.3em;
  }
  .contact {
    height: 490px;
  }
  .contactcontent {
    width: 100%;
    height: 60px;
    display: block;
  }
  .contactcompany {
    height: 100%;
    font-size: 1.65em;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }
  .contactcompanyen {
    font-size: 0.45em;
  }
  .contactinfo {
    width: 100%;
    display: block;
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },
};
</script>
